/* eslint-disable no-param-reassign, default-case */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import theme from '../../utils/theme'
import Icon from '../Icon'

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
    margin: '4px 0',
    borderRadius: 4,
    border: `1px solid ${`var(--gameday-questions-questionBorderColor, ${theme.questions.questionsBorderColor})`}`,
    padding: '10px 10px',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    '&:hover': {
      backgroundColor: `var(--gameday-questions-questionDisabledBg, ${theme.questions.questionDisabledBg})`,
      cursor: 'pointer',
    },
    '&:focus': {
      outline: 'none',
    },
    '& .rotate': {
      transform: 'rotate(90deg)',
    },
    '& .icon': {
      fontSize: '20px',
    },
    '&.locked': {
      backgroundColor: `var(--gameday-questions-questionDisabledBg, ${theme.questions.questionDisabledBg})`,
      '&:hover': {
        cursor: 'not-allowed',
      },
      '& .icon': {
        opacity: 0.7,
      },
    },
  },
  label: {
    marginLeft: '15px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.locked': {
      opacity: 0.7,
    },
  },
  coreFieldIcon: {
    position: 'absolute',
    top: 9,
    right: 5,
    color: theme.mainNav.iconColor,
    opacity: 0.3,
    pointerEvents: 'none',
    userSelect: 'none',
  },
})

const IconDisplay = icon => {
  switch (icon) {
    case 'Text':
    case 'Email address':
      return <Icon iconName="fieldText" />
    case 'Number':
      return <Icon iconName="fieldNumber" />
    case 'Picklist':
    case 'MultiMemberType':
    case 'multiPicklist':
    case 'Qualification Standard':
      return <Icon iconName="fieldPickList" />
    case 'Date':
      return <Icon iconName="fieldDate" />
    case 'Checkbox':
    case 'Radio button':
      return <Icon iconName="fieldCheckbox" />
    case 'Image Upload':
    case 'Document Upload':
      return <Icon iconName="fieldUpload" />
    case 'TermsAndConditions':
      return <Icon iconName="fieldTermsConditions" />
    case 'User':
      return <Icon iconName="fieldUser" />
    case 'Header Text':
      return <Icon iconName="fieldHeaderText" />
    case 'Paragraph Text':
      return <Icon iconName="fieldParagraphText" />
    case 'External':
      return <Icon iconName="externalLink2" />
  }

  return null
}

function QuestionListItem({ classes, icon, label, locked, onClick, definedByGameDay, isCoreField, className }) {
  if (definedByGameDay && (label === 'Team Code for Meet Manager' || label === 'Team Name for Meet Manager')) {
    icon = 'External'
  }
  return (
    <>
      {/** biome-ignore lint/a11y/useSemanticElements: TODO */}
      <div
        role="button"
        className={cn({ locked }, classes.root, className)}
        onClick={!locked && onClick}
        onKeyDown={!locked && onClick}
        tabIndex={0}
        aria-label={label}
      >
        {IconDisplay(icon)}
        <span className={cn({ locked }, classes.label)}>{label}</span>
      </div>
      {isCoreField && (
        <span className={classes.coreFieldIcon}>
          <Icon iconName="coreField" iconSize={26} />
        </span>
      )}
    </>
  )
}

QuestionListItem.defaultProps = {
  icon: '',
  label: '',
  onClick: () => {},
}

const QuestionItemComponent = withStyles(styles)(QuestionListItem)
QuestionItemComponent.displayName = 'QuestionListItem'
export default QuestionItemComponent
